// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteContactsBulkData, DeleteContactsBulkErrors, DeleteContactsBulkResponses, DeleteContactsByIdData, DeleteContactsByIdErrors, DeleteContactsByIdResponses, DeleteCountersByKeyData, DeleteCountersByKeyErrors, DeleteCountersByKeyLanguagesByLangData, DeleteCountersByKeyLanguagesByLangErrors, DeleteCountersByKeyLanguagesByLangResponses, DeleteCountersByKeyResponses, DeleteCountersByKeyRowsByRowKeyData, DeleteCountersByKeyRowsByRowKeyErrors, DeleteCountersByKeyRowsByRowKeyResponses, DeleteCustomFieldsByIdData, DeleteCustomFieldsByIdResponses, DeleteIntegrationsByIdData, DeleteIntegrationsByIdErrors, DeleteIntegrationsByIdResponses, DeleteMeTokensByIdData, DeleteMeTokensByIdErrors, DeleteMeTokensByIdResponses, DeleteSavedViewsByIdData, DeleteSavedViewsByIdResponses, DeleteSegmentsByIdData, DeleteSegmentsByIdResponses, DeleteTagsByIdData, DeleteTagsByIdErrors, DeleteTagsByIdResponses, GetAuditData, GetAuditErrors, GetAuditResponses, GetAuditStatsData, GetAuditStatsResponses, GetContactsByIdAnalyticsData, GetContactsByIdAnalyticsErrors, GetContactsByIdAnalyticsResponses, GetContactsByIdAtByVersionData, GetContactsByIdAtByVersionErrors, GetContactsByIdAtByVersionResponses, GetContactsByIdData, GetContactsByIdErrors, GetContactsByIdHistoryData, GetContactsByIdHistoryErrors, GetContactsByIdHistoryResponses, GetContactsByIdResponses, GetContactsData, GetContactsExportData, GetContactsExportErrors, GetContactsExportResponses, GetContactsResponses, GetCountersByKeyData, GetCountersByKeyErrors, GetCountersByKeyExportCsvData, GetCountersByKeyExportCsvResponses, GetCountersByKeyResponses, GetCountersByKeyRowsData, GetCountersByKeyRowsResponses, GetCountersData, GetCountersResponses, GetCustomFieldsData, GetCustomFieldsResponses, GetDocsData, GetDocsResponses, GetDocsSwaggerJsonData, GetDocsSwaggerJsonResponses, GetDocsSwaggerYamlData, GetDocsSwaggerYamlResponses, GetGdprConsentLogCsvData, GetGdprConsentLogCsvResponses, GetGdprConsentsByIdData, GetGdprConsentsByIdErrors, GetGdprConsentsByIdPreviewRenewalData, GetGdprConsentsByIdPreviewRenewalResponses, GetGdprConsentsByIdResponses, GetGdprConsentsData, GetGdprConsentsResponses, GetGdprStatsData, GetGdprStatsResponses, GetIntegrationsData, GetIntegrationsResponses, GetMeTokensData, GetMeTokensResponses, GetSavedViewsData, GetSavedViewsResponses, GetSegmentsByIdActiveSyncJobData, GetSegmentsByIdActiveSyncJobErrors, GetSegmentsByIdActiveSyncJobResponses, GetSegmentsByIdContactsData, GetSegmentsByIdContactsResponses, GetSegmentsData, GetSegmentsResponses, GetSyncJobsByIdData, GetSyncJobsByIdErrors, GetSyncJobsByIdResponses, GetTagsData, GetTagsResponses, PatchContactsBulkData, PatchContactsBulkErrors, PatchContactsBulkResponses, PatchContactsByIdData, PatchContactsByIdErrors, PatchContactsByIdResponses, PatchCountersByKeyRowsByRowKeyData, PatchCountersByKeyRowsByRowKeyErrors, PatchCountersByKeyRowsByRowKeyResponses, PatchCountersByKeySchemaData, PatchCountersByKeySchemaErrors, PatchCountersByKeySchemaResponses, PostContactsByIdRestoreData, PostContactsByIdRestoreErrors, PostContactsByIdRestoreResponses, PostContactsData, PostContactsErrors, PostContactsImportData, PostContactsImportEcomailData, PostContactsImportEcomailErrors, PostContactsImportEcomailResponses, PostContactsImportErrors, PostContactsImportResponses, PostContactsResponses, PostContactsSearchData, PostContactsSearchErrors, PostContactsSearchResponses, PostCountersByKeyImportData, PostCountersByKeyImportErrors, PostCountersByKeyImportResponses, PostCountersByKeyLanguagesData, PostCountersByKeyLanguagesResponses, PostCountersByKeyRowsData, PostCountersByKeyRowsErrors, PostCountersByKeyRowsResponses, PostCountersByKeyTranslationsAcceptData, PostCountersByKeyTranslationsAcceptErrors, PostCountersByKeyTranslationsAcceptResponses, PostCountersData, PostCountersErrors, PostCountersResponses, PostCustomFieldsData, PostCustomFieldsResponses, PostGdprConsentsBulkResendData, PostGdprConsentsBulkResendResponses, PostGdprConsentsByIdResendData, PostGdprConsentsByIdResendResponses, PostGdprConsentsByIdWithdrawData, PostGdprConsentsByIdWithdrawErrors, PostGdprConsentsByIdWithdrawResponses, PostGdprDsarData, PostGdprDsarResponses, PostGdprRtbfData, PostGdprRtbfResponses, PostGdprRunRenewalJobData, PostGdprRunRenewalJobResponses, PostImportsContactsData, PostImportsContactsErrors, PostImportsContactsResponses, PostImportsLinkedinData, PostImportsLinkedinErrors, PostImportsLinkedinResponses, PostIntegrationsData, PostIntegrationsErrors, PostIntegrationsResponses, PostMeTokensData, PostMeTokensResponses, PostSavedViewsData, PostSavedViewsResponses, PostSegmentsByIdSyncData, PostSegmentsByIdSyncErrors, PostSegmentsByIdSyncResponses, PostSegmentsData, PostSegmentsResponses, PostTagsByIdRecomputeData, PostTagsByIdRecomputeResponses, PostTagsData, PostTagsErrors, PostTagsResponses, PutContactsByIdData, PutContactsByIdErrors, PutContactsByIdResponses, PutSavedViewsByIdData, PutSavedViewsByIdResponses, PutSegmentsByIdData, PutSegmentsByIdErrors, PutSegmentsByIdResponses, PutTagsByIdData, PutTagsByIdErrors, PutTagsByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Query audit logs
 *
 * Retrieve audit logs with filtering and pagination
 */
export const getAudit = <ThrowOnError extends boolean = false>(options?: Options<GetAuditData, ThrowOnError>) => (options?.client ?? client).get<GetAuditResponses, GetAuditErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/audit',
    ...options
});

/**
 * Audit log aggregations for the audit-logs page stat cards
 */
export const getAuditStats = <ThrowOnError extends boolean = false>(options?: Options<GetAuditStatsData, ThrowOnError>) => (options?.client ?? client).get<GetAuditStatsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/audit/stats',
    ...options
});

/**
 * List contacts
 *
 * Get a paginated list of contacts with optional filtering
 */
export const getContacts = <ThrowOnError extends boolean = false>(options?: Options<GetContactsData, ThrowOnError>) => (options?.client ?? client).get<GetContactsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts',
    ...options
});

/**
 * Create a new contact
 *
 * Create a new contact with profile, contact info, and consents
 */
export const postContacts = <ThrowOnError extends boolean = false>(options: Options<PostContactsData, ThrowOnError>) => (options.client ?? client).post<PostContactsResponses, PostContactsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk delete contacts
 *
 * Soft delete multiple contacts
 */
export const deleteContactsBulk = <ThrowOnError extends boolean = false>(options: Options<DeleteContactsBulkData, ThrowOnError>) => (options.client ?? client).delete<DeleteContactsBulkResponses, DeleteContactsBulkErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/_bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk update contacts
 *
 * Apply same patch operations to multiple contacts
 */
export const patchContactsBulk = <ThrowOnError extends boolean = false>(options: Options<PatchContactsBulkData, ThrowOnError>) => (options.client ?? client).patch<PatchContactsBulkResponses, PatchContactsBulkErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/_bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search contacts
 *
 * Advanced search with custom query and sorting
 */
export const postContactsSearch = <ThrowOnError extends boolean = false>(options: Options<PostContactsSearchData, ThrowOnError>) => (options.client ?? client).post<PostContactsSearchResponses, PostContactsSearchErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/_search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Export contacts
 *
 * Export contacts in CSV or JSON format
 */
export const getContactsExport = <ThrowOnError extends boolean = false>(options?: Options<GetContactsExportData, ThrowOnError>) => (options?.client ?? client).get<GetContactsExportResponses, GetContactsExportErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/export',
    ...options
});

/**
 * Import contacts
 *
 * Import contacts from CSV file
 */
export const postContactsImport = <ThrowOnError extends boolean = false>(options: Options<PostContactsImportData, ThrowOnError>) => (options.client ?? client).post<PostContactsImportResponses, PostContactsImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Import contacts from Ecomail CSV
 *
 * Import contacts from Ecomail export format with semicolon delimiter (supports dynamic columns)
 */
export const postContactsImportEcomail = <ThrowOnError extends boolean = false>(options: Options<PostContactsImportEcomailData, ThrowOnError>) => (options.client ?? client).post<PostContactsImportEcomailResponses, PostContactsImportEcomailErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/import/ecomail',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete contact
 *
 * Soft delete a contact (sets doNotContact flag)
 */
export const deleteContactsById = <ThrowOnError extends boolean = false>(options: Options<DeleteContactsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteContactsByIdResponses, DeleteContactsByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/{id}',
    ...options
});

/**
 * Get contact by ID
 *
 * Retrieve a specific contact by its ID
 */
export const getContactsById = <ThrowOnError extends boolean = false>(options: Options<GetContactsByIdData, ThrowOnError>) => (options.client ?? client).get<GetContactsByIdResponses, GetContactsByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/{id}',
    ...options
});

/**
 * Patch contact
 *
 * Apply JSON Patch operations to update specific fields of a contact
 */
export const patchContactsById = <ThrowOnError extends boolean = false>(options: Options<PatchContactsByIdData, ThrowOnError>) => (options.client ?? client).patch<PatchContactsByIdResponses, PatchContactsByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update contact
 *
 * Replace entire contact with new data
 */
export const putContactsById = <ThrowOnError extends boolean = false>(options: Options<PutContactsByIdData, ThrowOnError>) => (options.client ?? client).put<PutContactsByIdResponses, PutContactsByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get complete contact data for analytics
 *
 * Retrieve full contact JSON structure for analytics purposes
 */
export const getContactsByIdAnalytics = <ThrowOnError extends boolean = false>(options: Options<GetContactsByIdAnalyticsData, ThrowOnError>) => (options.client ?? client).get<GetContactsByIdAnalyticsResponses, GetContactsByIdAnalyticsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/{id}/analytics',
    ...options
});

/**
 * Get contact at specific version
 *
 * Retrieve a contact as it was at a specific version
 */
export const getContactsByIdAtByVersion = <ThrowOnError extends boolean = false>(options: Options<GetContactsByIdAtByVersionData, ThrowOnError>) => (options.client ?? client).get<GetContactsByIdAtByVersionResponses, GetContactsByIdAtByVersionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/{id}/at/{version}',
    ...options
});

/**
 * Get contact history
 *
 * Retrieve version history for a contact
 */
export const getContactsByIdHistory = <ThrowOnError extends boolean = false>(options: Options<GetContactsByIdHistoryData, ThrowOnError>) => (options.client ?? client).get<GetContactsByIdHistoryResponses, GetContactsByIdHistoryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/{id}/history',
    ...options
});

/**
 * Restore a contact to a previous version
 *
 * Re-applies a historical contact snapshot as a new update, writing a new audit log entry.
 */
export const postContactsByIdRestore = <ThrowOnError extends boolean = false>(options: Options<PostContactsByIdRestoreData, ThrowOnError>) => (options.client ?? client).post<PostContactsByIdRestoreResponses, PostContactsByIdRestoreErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/contacts/{id}/restore',
    ...options
});

/**
 * List counter tables
 *
 * Returns slim metadata for every counter table — name, key, row count, field count, languages, usedIn, last updated. Row data is omitted.
 */
export const getCounters = <ThrowOnError extends boolean = false>(options?: Options<GetCountersData, ThrowOnError>) => (options?.client ?? client).get<GetCountersResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters',
    ...options
});

/**
 * Create a counter table
 */
export const postCounters = <ThrowOnError extends boolean = false>(options: Options<PostCountersData, ThrowOnError>) => (options.client ?? client).post<PostCountersResponses, PostCountersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a counter table
 *
 * Refuses with 409 if usedIn > 0.
 */
export const deleteCountersByKey = <ThrowOnError extends boolean = false>(options: Options<DeleteCountersByKeyData, ThrowOnError>) => (options.client ?? client).delete<DeleteCountersByKeyResponses, DeleteCountersByKeyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}',
    ...options
});

/**
 * Get a counter table
 *
 * Full table document including rows. Pass ?lang=cs to flatten i18n maps to that language.
 */
export const getCountersByKey = <ThrowOnError extends boolean = false>(options: Options<GetCountersByKeyData, ThrowOnError>) => (options.client ?? client).get<GetCountersByKeyResponses, GetCountersByKeyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}',
    ...options
});

/**
 * Export rows as CSV
 *
 * ?lang=<code> flattens i18n columns; ?lang=all emits one column per (i18n field × language).
 */
export const getCountersByKeyExportCsv = <ThrowOnError extends boolean = false>(options: Options<GetCountersByKeyExportCsvData, ThrowOnError>) => (options.client ?? client).get<GetCountersByKeyExportCsvResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}/export.csv',
    ...options
});

/**
 * Import rows from CSV
 *
 * Multipart upload. Pass ?dryRun=1 to receive a diff without writing. Columns: key, value, description, parent. Additional columns map onto custom fields. For i18n fields, accept either flattened columns (value_cs, value_en) or a single column populated for the table's defaultLang.
 */
export const postCountersByKeyImport = <ThrowOnError extends boolean = false>(options: Options<PostCountersByKeyImportData, ThrowOnError>) => (options.client ?? client).post<PostCountersByKeyImportResponses, PostCountersByKeyImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Add a language to a counter table
 *
 * If autoTranslate=true, queues a counter.translate background job that fills row drafts via OpenAI. Drafts must be accepted via /translations/accept before becoming canonical.
 */
export const postCountersByKeyLanguages = <ThrowOnError extends boolean = false>(options: Options<PostCountersByKeyLanguagesData, ThrowOnError>) => (options.client ?? client).post<PostCountersByKeyLanguagesResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}/languages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a language from a counter table
 */
export const deleteCountersByKeyLanguagesByLang = <ThrowOnError extends boolean = false>(options: Options<DeleteCountersByKeyLanguagesByLangData, ThrowOnError>) => (options.client ?? client).delete<DeleteCountersByKeyLanguagesByLangResponses, DeleteCountersByKeyLanguagesByLangErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}/languages/{lang}',
    ...options
});

/**
 * List counter rows
 */
export const getCountersByKeyRows = <ThrowOnError extends boolean = false>(options: Options<GetCountersByKeyRowsData, ThrowOnError>) => (options.client ?? client).get<GetCountersByKeyRowsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}/rows',
    ...options
});

/**
 * Add a row to a counter table
 */
export const postCountersByKeyRows = <ThrowOnError extends boolean = false>(options: Options<PostCountersByKeyRowsData, ThrowOnError>) => (options.client ?? client).post<PostCountersByKeyRowsResponses, PostCountersByKeyRowsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}/rows',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a counter row
 */
export const deleteCountersByKeyRowsByRowKey = <ThrowOnError extends boolean = false>(options: Options<DeleteCountersByKeyRowsByRowKeyData, ThrowOnError>) => (options.client ?? client).delete<DeleteCountersByKeyRowsByRowKeyResponses, DeleteCountersByKeyRowsByRowKeyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}/rows/{rowKey}',
    ...options
});

/**
 * Update a counter row
 */
export const patchCountersByKeyRowsByRowKey = <ThrowOnError extends boolean = false>(options: Options<PatchCountersByKeyRowsByRowKeyData, ThrowOnError>) => (options.client ?? client).patch<PatchCountersByKeyRowsByRowKeyResponses, PatchCountersByKeyRowsByRowKeyErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}/rows/{rowKey}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a counter table's custom field schema
 *
 * Destructive changes (removing a field, changing a field type) require ?confirm=drop-data.
 */
export const patchCountersByKeySchema = <ThrowOnError extends boolean = false>(options: Options<PatchCountersByKeySchemaData, ThrowOnError>) => (options.client ?? client).patch<PatchCountersByKeySchemaResponses, PatchCountersByKeySchemaErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}/schema',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accept pending draft translations
 */
export const postCountersByKeyTranslationsAccept = <ThrowOnError extends boolean = false>(options: Options<PostCountersByKeyTranslationsAcceptData, ThrowOnError>) => (options.client ?? client).post<PostCountersByKeyTranslationsAcceptResponses, PostCountersByKeyTranslationsAcceptErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/counters/{key}/translations/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List custom field definitions
 */
export const getCustomFields = <ThrowOnError extends boolean = false>(options?: Options<GetCustomFieldsData, ThrowOnError>) => (options?.client ?? client).get<GetCustomFieldsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/custom-fields',
    ...options
});

/**
 * Create a custom field definition
 */
export const postCustomFields = <ThrowOnError extends boolean = false>(options: Options<PostCustomFieldsData, ThrowOnError>) => (options.client ?? client).post<PostCustomFieldsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/custom-fields',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a custom field definition
 */
export const deleteCustomFieldsById = <ThrowOnError extends boolean = false>(options: Options<DeleteCustomFieldsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteCustomFieldsByIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/custom-fields/{id}',
    ...options
});

/**
 * API Documentation
 *
 * Interactive API documentation using Scalar
 */
export const getDocs = <ThrowOnError extends boolean = false>(options?: Options<GetDocsData, ThrowOnError>) => (options?.client ?? client).get<GetDocsResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/docs',
    ...options
});

/**
 * OpenAPI JSON Specification
 *
 * Raw OpenAPI 3.0 specification in JSON format
 */
export const getDocsSwaggerJson = <ThrowOnError extends boolean = false>(options?: Options<GetDocsSwaggerJsonData, ThrowOnError>) => (options?.client ?? client).get<GetDocsSwaggerJsonResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/docs/swagger.json',
    ...options
});

/**
 * OpenAPI YAML Specification
 *
 * Raw OpenAPI 3.0 specification in YAML format
 */
export const getDocsSwaggerYaml = <ThrowOnError extends boolean = false>(options?: Options<GetDocsSwaggerYamlData, ThrowOnError>) => (options?.client ?? client).get<GetDocsSwaggerYamlResponses, unknown, ThrowOnError>({
    responseType: 'text',
    url: '/docs/swagger.yaml',
    ...options
});

/**
 * Export the consent audit trail as CSV
 */
export const getGdprConsentLogCsv = <ThrowOnError extends boolean = false>(options?: Options<GetGdprConsentLogCsvData, ThrowOnError>) => (options?.client ?? client).get<GetGdprConsentLogCsvResponses, unknown, ThrowOnError>({
    responseType: 'text',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/consent-log.csv',
    ...options
});

/**
 * List consents
 *
 * Filter by status (granted/expiring/pending/withdrawn/all), type, source, granted-date range, and free-text q.
 */
export const getGdprConsents = <ThrowOnError extends boolean = false>(options?: Options<GetGdprConsentsData, ThrowOnError>) => (options?.client ?? client).get<GetGdprConsentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/consents',
    ...options
});

/**
 * Bulk-resend renewal emails
 *
 * Queues one job that fans out to the listed consents. The spec mentions a 200/hour throttle; v1 enforces it loosely by capping the per-request batch at 200 — a real token bucket lands later.
 */
export const postGdprConsentsBulkResend = <ThrowOnError extends boolean = false>(options: Options<PostGdprConsentsBulkResendData, ThrowOnError>) => (options.client ?? client).post<PostGdprConsentsBulkResendResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/consents/bulk-resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a consent
 */
export const getGdprConsentsById = <ThrowOnError extends boolean = false>(options: Options<GetGdprConsentsByIdData, ThrowOnError>) => (options.client ?? client).get<GetGdprConsentsByIdResponses, GetGdprConsentsByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/consents/{id}',
    ...options
});

/**
 * Server-render the renewal email for a consent
 *
 * Returns subject + HTML so the Resend modal's live preview pane stays in sync with what will actually be sent.
 */
export const getGdprConsentsByIdPreviewRenewal = <ThrowOnError extends boolean = false>(options: Options<GetGdprConsentsByIdPreviewRenewalData, ThrowOnError>) => (options.client ?? client).get<GetGdprConsentsByIdPreviewRenewalResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/consents/{id}/preview-renewal',
    ...options
});

/**
 * Resend a renewal email for one consent
 */
export const postGdprConsentsByIdResend = <ThrowOnError extends boolean = false>(options: Options<PostGdprConsentsByIdResendData, ThrowOnError>) => (options.client ?? client).post<PostGdprConsentsByIdResendResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/consents/{id}/resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark a consent withdrawn
 *
 * Adds the gdpr:withdrawn tag to the parent contact and freezes basis to "withdrawn".
 */
export const postGdprConsentsByIdWithdraw = <ThrowOnError extends boolean = false>(options: Options<PostGdprConsentsByIdWithdrawData, ThrowOnError>) => (options.client ?? client).post<PostGdprConsentsByIdWithdrawResponses, PostGdprConsentsByIdWithdrawErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/consents/{id}/withdraw',
    ...options
});

/**
 * Generate a Data Subject Access Request package
 *
 * Queues a gdpr.dsar.export job. The resulting JSON package is uploaded to MinIO; poll /sync-jobs/{id} for the resultUrl.
 */
export const postGdprDsar = <ThrowOnError extends boolean = false>(options: Options<PostGdprDsarData, ThrowOnError>) => (options.client ?? client).post<PostGdprDsarResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/dsar',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Right-to-be-forgotten / anonymise a contact
 *
 * Strips PII from the contact and from every consent referencing it. Analytics aggregates are preserved. Requires confirm:true to guard against accidental triggering.
 */
export const postGdprRtbf = <ThrowOnError extends boolean = false>(options: Options<PostGdprRtbfData, ThrowOnError>) => (options.client ?? client).post<PostGdprRtbfResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/rtbf',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Run the consent expiration scan
 *
 * Idempotent inline sweep that flags consents entering the 30-day window as `expiring`. Designed to run nightly at 0 2 * * *; the cron scheduler is a follow-up — for now operators trigger it manually here. The auto-queue of first reminders (described in §1.4 of the handoff) is a TODO; for now this endpoint only updates statuses.
 */
export const postGdprRunRenewalJob = <ThrowOnError extends boolean = false>(options?: Options<PostGdprRunRenewalJobData, ThrowOnError>) => (options?.client ?? client).post<PostGdprRunRenewalJobResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/run-renewal-job',
    ...options
});

/**
 * Counts for the GDPR dashboard stat strip
 */
export const getGdprStats = <ThrowOnError extends boolean = false>(options?: Options<GetGdprStatsData, ThrowOnError>) => (options?.client ?? client).get<GetGdprStatsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/gdpr/stats',
    ...options
});

/**
 * Find-or-create a contact by email + source (token-only)
 *
 * Token-only import: email is the natural key. Returns the contact id either way; integration uses that id to attach media.
 */
export const postImportsContacts = <ThrowOnError extends boolean = false>(options: Options<PostImportsContactsData, ThrowOnError>) => (options.client ?? client).post<PostImportsContactsResponses, PostImportsContactsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/imports/contacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import a LinkedIn profile PDF and either create or merge into an existing contact
 *
 * PDF body, max 10MB. Auto-processes — looks up by extracted email, merges fill-empty if found, otherwise creates. Extras land in a contact Note.
 */
export const postImportsLinkedin = <ThrowOnError extends boolean = false>(options?: Options<PostImportsLinkedinData, ThrowOnError>) => (options?.client ?? client).post<PostImportsLinkedinResponses, PostImportsLinkedinErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/imports/linkedin',
    ...options
});

/**
 * List configured integrations
 */
export const getIntegrations = <ThrowOnError extends boolean = false>(options?: Options<GetIntegrationsData, ThrowOnError>) => (options?.client ?? client).get<GetIntegrationsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/integrations',
    ...options
});

/**
 * Create an integration
 */
export const postIntegrations = <ThrowOnError extends boolean = false>(options: Options<PostIntegrationsData, ThrowOnError>) => (options.client ?? client).post<PostIntegrationsResponses, PostIntegrationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/integrations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an integration
 */
export const deleteIntegrationsById = <ThrowOnError extends boolean = false>(options: Options<DeleteIntegrationsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteIntegrationsByIdResponses, DeleteIntegrationsByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/integrations/{id}',
    ...options
});

/**
 * List the caller's personal access tokens
 */
export const getMeTokens = <ThrowOnError extends boolean = false>(options?: Options<GetMeTokensData, ThrowOnError>) => (options?.client ?? client).get<GetMeTokensResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/me/tokens',
    ...options
});

/**
 * Create a new personal access token
 *
 * Returns the raw token exactly once. Store it securely; the server only keeps a hash.
 */
export const postMeTokens = <ThrowOnError extends boolean = false>(options: Options<PostMeTokensData, ThrowOnError>) => (options.client ?? client).post<PostMeTokensResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/me/tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke a personal access token
 */
export const deleteMeTokensById = <ThrowOnError extends boolean = false>(options: Options<DeleteMeTokensByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteMeTokensByIdResponses, DeleteMeTokensByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/me/tokens/{id}',
    ...options
});

/**
 * List saved views
 */
export const getSavedViews = <ThrowOnError extends boolean = false>(options?: Options<GetSavedViewsData, ThrowOnError>) => (options?.client ?? client).get<GetSavedViewsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/saved-views',
    ...options
});

/**
 * Create a saved view
 */
export const postSavedViews = <ThrowOnError extends boolean = false>(options: Options<PostSavedViewsData, ThrowOnError>) => (options.client ?? client).post<PostSavedViewsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/saved-views',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a saved view
 */
export const deleteSavedViewsById = <ThrowOnError extends boolean = false>(options: Options<DeleteSavedViewsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteSavedViewsByIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/saved-views/{id}',
    ...options
});

/**
 * Update a saved view
 */
export const putSavedViewsById = <ThrowOnError extends boolean = false>(options: Options<PutSavedViewsByIdData, ThrowOnError>) => (options.client ?? client).put<PutSavedViewsByIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/saved-views/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List segments
 */
export const getSegments = <ThrowOnError extends boolean = false>(options?: Options<GetSegmentsData, ThrowOnError>) => (options?.client ?? client).get<GetSegmentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/segments',
    ...options
});

/**
 * Create a segment
 */
export const postSegments = <ThrowOnError extends boolean = false>(options: Options<PostSegmentsData, ThrowOnError>) => (options.client ?? client).post<PostSegmentsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/segments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a segment
 */
export const deleteSegmentsById = <ThrowOnError extends boolean = false>(options: Options<DeleteSegmentsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteSegmentsByIdResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/segments/{id}',
    ...options
});

/**
 * Update a segment
 */
export const putSegmentsById = <ThrowOnError extends boolean = false>(options: Options<PutSegmentsByIdData, ThrowOnError>) => (options.client ?? client).put<PutSegmentsByIdResponses, PutSegmentsByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/segments/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the active sync job for a segment
 */
export const getSegmentsByIdActiveSyncJob = <ThrowOnError extends boolean = false>(options: Options<GetSegmentsByIdActiveSyncJobData, ThrowOnError>) => (options.client ?? client).get<GetSegmentsByIdActiveSyncJobResponses, GetSegmentsByIdActiveSyncJobErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/segments/{id}/active-sync-job',
    ...options
});

/**
 * List contacts matching a segment
 */
export const getSegmentsByIdContacts = <ThrowOnError extends boolean = false>(options: Options<GetSegmentsByIdContactsData, ThrowOnError>) => (options.client ?? client).get<GetSegmentsByIdContactsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/segments/{id}/contacts',
    ...options
});

/**
 * Start a segment-to-integration sync job
 */
export const postSegmentsByIdSync = <ThrowOnError extends boolean = false>(options: Options<PostSegmentsByIdSyncData, ThrowOnError>) => (options.client ?? client).post<PostSegmentsByIdSyncResponses, PostSegmentsByIdSyncErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/segments/{id}/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a sync job
 */
export const getSyncJobsById = <ThrowOnError extends boolean = false>(options: Options<GetSyncJobsByIdData, ThrowOnError>) => (options.client ?? client).get<GetSyncJobsByIdResponses, GetSyncJobsByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/sync-jobs/{id}',
    ...options
});

/**
 * List tags
 *
 * List all tags with their live contactCount values.
 */
export const getTags = <ThrowOnError extends boolean = false>(options?: Options<GetTagsData, ThrowOnError>) => (options?.client ?? client).get<GetTagsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags',
    ...options
});

/**
 * Create a tag
 */
export const postTags = <ThrowOnError extends boolean = false>(options: Options<PostTagsData, ThrowOnError>) => (options.client ?? client).post<PostTagsResponses, PostTagsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a tag
 */
export const deleteTagsById = <ThrowOnError extends boolean = false>(options: Options<DeleteTagsByIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteTagsByIdResponses, DeleteTagsByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags/{id}',
    ...options
});

/**
 * Update a tag
 */
export const putTagsById = <ThrowOnError extends boolean = false>(options: Options<PutTagsByIdData, ThrowOnError>) => (options.client ?? client).put<PutTagsByIdResponses, PutTagsByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Re-evaluate a tag's auto-rule against all contacts
 */
export const postTagsByIdRecompute = <ThrowOnError extends boolean = false>(options: Options<PostTagsByIdRecomputeData, ThrowOnError>) => (options.client ?? client).post<PostTagsByIdRecomputeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/tags/{id}/recompute',
    ...options
});
